import React, { useEffect, useRef } from "react";
import p5 from "p5";
import gsap from "gsap";


const LoadingLine = () => {
  const wrapperRef = useRef(null);
  const p5Instance = useRef(null);
  const isRunning = useRef(false);

  // 애니메이션 관련 변수들
  const screenWidth = 40;
  const screenHeight = 40;
  const cx = screenWidth / 2;
  const cy = screenHeight / 2;

  const num = 5;
  const vScale = 2;
  const bw = 2 * vScale;
  const bh = 8 * vScale;
  const baseH = 2 * vScale;
  const gap = 2 * vScale;

  const sx = cx - (num * (bw + gap) - gap) * 0.5;
  const sy = cy;

  let cnt = 0;

  useEffect(() => {
    if (isRunning.current) return;
    isRunning.current = true;

    const sketch = (p) => {
      p.setup = () => {
        p.createCanvas(screenWidth, screenHeight);
        p.angleMode(p.DEGREES);
        p.noStroke();
      };

      p.draw = () => {
        if (!isRunning.current) return;
        p.clear();
        p.background(255);

        for (let i = 0; i < num; i++) {
          const tx = sx + i * (bw + gap);
          let ty = sy;
          const size = baseH + bh;
          const th = size + p.cos(cnt + (360 / num) * i) * size * 0.7;
          ty = ty - th / 2;
          p.fill(31, 31, 31, 255);
          p.rect(tx, ty, bw, th);
        }
        cnt -= 7;
      };
    };

    p5Instance.current = new p5(sketch, wrapperRef.current);

    gsap.to(wrapperRef.current, {
      opacity: 1,
      duration: 0.6,
      ease: "power1.inOut",
    });
    gsap.to('.loading-container', {
      opacity: 1,
      duration: 0.6,
      ease: "power1.inOut",
    });
    return () => {
      // cleanup
      isRunning.current = false;
      gsap.to(wrapperRef.current, { opacity: 0, duration: 0.2 });
      if (p5Instance.current) {
        p5Instance.current.remove();
        p5Instance.current = null;
      }
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      className="canvas-wrapper canvas-inner"
      style={{ opacity: 0 }}
    />
  );
};

export default LoadingLine;
